import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
} from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";

import moment from "moment";
import * as XLSX from "xlsx";
import useTableScroll from "../useTableScroll";

const ActualizarPreciosExcel = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const txtFile = useRef();
  const [updateProduct, setUpdateProduct] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const headCells = [
    { label: "CODIGO PRODUCTO", textAlign: "center" },
    { label: "DESCRIPCIÓN", textAlign: "center" },
    { label: "UNIDAD", textAlign: "center" },
    { label: "COSTO", textAlign: "center" },
    { label: "PRECIO", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const blanquear = () => {
    setActivate(false);
    setUpdateProduct([]);
    txtFile.current.value = "";
  };

  const procesarRegistro = (body) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/cerveceria/actualizar/2`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setUpdateProduct([]);
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: `${response.data.contar} registro modificado correctamente`,
            icono: "exito",
          });

          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistros = (productFile) => {
    let campos = "codigo";
    let nomtab = "producto";
    let orden = "idproducto";
    const datos = [];

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              datos.push(response.data[index].codigo);
            }
            procesarPrecioProd(datos, productFile);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const calcularUtilidadxValor = (producto) => {
    let iva = producto[5];
    let costo = producto[6];
    let venta = producto[8];

    let mon = (costo * iva) / 100;
    mon = mon + costo;
    let mon3 = 0.0;

    mon3 = (venta - mon) / mon;
    mon3 = mon3 * 100;
    return mon3;
  };

  const calcularUtilidadxValorAlter = (producto) => {
    let iva = producto[5];
    let costo = producto[4];
    let venta = producto[7];

    let mon = (costo * iva) / 100;
    mon = mon + costo;
    let mon3 = 0.0;

    mon3 = (venta - mon) / mon;
    mon3 = mon3 * 100;
    return mon3;
  };

  const updateProcess = () => {
    let productos = [];
    for (let i = 0; i < updateProduct.length; i++) {
      productos.push({
        codigo: updateProduct[i][1],
        nombre: updateProduct[i][2],
        nombrecorto: updateProduct[i][2],
        ivacompra: updateProduct[i][5],
        ivaventa: updateProduct[i][9],
        exento: parseFloat(updateProduct[i][9]) > 0.0 ? false : true,
        valorfactor: updateProduct[i][3],
        tipofactor: parseInt(updateProduct[i][3]) > 1 ? 1 : 0,
        costoproveedor: updateProduct[i][6],
        costocalculado: updateProduct[i][6],
        ultimocosto: updateProduct[i][6],
        costopromedio: updateProduct[i][6],
        costoproveedoralter: updateProduct[i][4],
        costocalculadoalter: updateProduct[i][4],
        ultimocostoalter: updateProduct[i][4],
        costopromedioalter: updateProduct[i][4],
        utipreciomaxi: calcularUtilidadxValor(updateProduct[i]),
        utiprecioofe: calcularUtilidadxValor(updateProduct[i]),
        utipreciomayor: calcularUtilidadxValor(updateProduct[i]),
        utipreciomini: calcularUtilidadxValor(updateProduct[i]),
        utipreciomaxialter: calcularUtilidadxValorAlter(updateProduct[i]),
        utiprecioofealter: calcularUtilidadxValorAlter(updateProduct[i]),
        utipreciomayoralter: calcularUtilidadxValorAlter(updateProduct[i]),
        utipreciominialter: calcularUtilidadxValorAlter(updateProduct[i]),
      });
    }
    procesarRegistro(2, { productos: JSON.stringify(productos) });
  };

  const handleInputChange = (e) => {
    if (e.target.name === "file" && e.target.files.length > 0) {
      setActivate(true);
      setUpdateProduct([]);
      let hojas = [];
      let reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (SheetName) {
          var objData = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[SheetName]
          );
          hojas.push({
            data: objData,
            SheetName,
          });
        });

        let titulos = [];
        let produc = [];
        let titulo_sigue = false;
        let produc_sigue = false;
        let rueda = Object.keys(hojas[0].data[0]);
        try {
          for (let i = 0; i < rueda.length; i++) {
            titulos.push({
              label: rueda[i].toUpperCase(),
              textAlign: "center",
            });
          }
          titulo_sigue = true;
        } catch (error) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "el archivo xlsx esta mal formado",
            icono: "error",
          });
          setActivate(false);
        }

        try {
          for (let l = 1; l < hojas[0].data.length - 1; l++) {
            let obj = {};
            let array = Object.values(hojas[0].data[l]);
            for (let k = 0; k < array.length; k++) {
              obj[k] = array[k];
            }
            produc.push(obj);
          }
          produc_sigue = true;
        } catch (error) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "el archivo xlsx esta mal formado",
            icono: "error",
          });
          setActivate(false);
        }

        if (titulo_sigue === true && produc_sigue === true) {
          seleccionarRegistros(produc);
        } else {
          setUpdateProduct([]);
        }
      };
    }
  };

  const procesarPrecioProd = (cursorProduct, fileProduct) => {
    let element = fileProduct;
    const element0 = [];
    const viejos = [];

    for (let i = 0; i < fileProduct.length; i++) {
      for (let x = 0; x < cursorProduct.length; x++) {
        if (
          cursorProduct[x].toString().trim().toUpperCase() ===
          fileProduct[i][0].toString().trim().toUpperCase()
        ) {
          viejos.push(fileProduct[i][0]);
          element0.push(fileProduct[i]);
        }
      }
    }

    for (let i = 0; i < element.length; i++) {
      for (let x = 0; x < viejos.length; x++) {
        if (
          viejos[x].toString().trim().toUpperCase() ===
          element[i][0].toString().trim().toUpperCase()
        ) {
          element = element.filter(
            (value) =>
              value[0].toString().trim().toUpperCase() !==
              element[i][0].toString().trim().toUpperCase()
          );
        }
      }
    }

    setUpdateProduct(element0);
    setActivate(false);
  };

  const descargarxlsx = () => {
    setActivate(true);
    let endpoint = `${op.reportes}/productos?afiliado=${organizacion}&reporte=ReporteProductosExcel`;
    axios
      .get(endpoint, {
        responseType: "arraybuffer",
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "LISTA PRECIOS PRODUCTOS.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setActivate(false));
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-12 py-3 mx-auto card shadow ">
            <Dimmer active={activate} inverted>
              <Loader inverted>cargando...</Loader>
            </Dimmer>
            <div className="row col-md-12 mx-auto ">
              <h1>ACTUALIZAR PRECIOS</h1>
              <div className="input-group input-group-sm mb-2 col-md-12 justify-content-between">
                <input
                  required
                  type="file"
                  name="file"
                  id="file"
                  ref={txtFile}
                  className="form-control col-md-3"
                  onChange={handleInputChange}
                  placeholder="Ingrese Archivo Excel."
                />
              </div>

              <div className="col-md-12 mx-auto mb-3">
                <TblContainer
                  container={{
                    height: 350,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {updateProduct.length > 0 &&
                      updateProduct.map((item, index) => (
                        <TableRow
                          key={index}
                          style={{
                            padding: "0",
                            backgroundColor: "transparent",
                          }}
                        >
                          {Object.values(item) &&
                            Object.values(item).map((item2, x) => (
                              <TableCell
                                key={x}
                                className="align-baseline p-0"
                                style={{
                                  textAlign: "center",
                                  border: "solid 1px #000000",
                                }}
                              >
                                {item2}
                              </TableCell>
                            ))}
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <div className="row col-md-12 mt-3">
                  <button
                    onClick={descargarxlsx}
                    className="btn btn-sm btn-success rounded-pill col-md-2 mb-3"
                  >
                    <i className="fas fa-file-excel"> Descargar</i>
                  </button>
                  <button
                    type="button"
                    disabled={updateProduct.length === 0}
                    className="btn btn-warning btn-sm rounded-pill col-md-2 mb-3"
                    onClick={updateProcess}
                  >
                    <i className="fas fa-edit"> Actualizar</i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm rounded-pill col-md-2 mb-3"
                    onClick={blanquear}
                  >
                    <i className="fas fa-times"> Cancelar</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default ActualizarPreciosExcel;



// WEBPACK FOOTER //
// ./src/components/almacen/actualizarPreciosExcel.js